/**
 * mega-menu-allproducts.js
 *
 * Activates the server-rendered "All Products" mega menu.
 * The markup is rendered directly in Liquid from the Shopify Main Menu tree,
 * and this script only handles interaction states plus compact styling for
 * smaller Horizon submenus.
 */
(function () {
  'use strict';

  var COMPACT_THRESHOLD = 12;

  function enhanceAllProductsMenu(root) {
    var tabs = root.querySelectorAll('.ap-mega__dept');
    var panels = root.querySelectorAll('.ap-mega__panel');
    if (!tabs.length || tabs.length !== panels.length) return;

    function activate(index) {
      for (var tabIndex = 0; tabIndex < tabs.length; tabIndex++) {
        var isActive = tabIndex === index;
        tabs[tabIndex].setAttribute('aria-selected', isActive ? 'true' : 'false');
        tabs[tabIndex].setAttribute('tabindex', isActive ? '0' : '-1');

        if (isActive) {
          panels[tabIndex].setAttribute('data-active', '');
          panels[tabIndex].removeAttribute('hidden');
          panels[tabIndex].setAttribute('aria-hidden', 'false');
        } else {
          panels[tabIndex].removeAttribute('data-active');
          panels[tabIndex].setAttribute('hidden', '');
          panels[tabIndex].setAttribute('aria-hidden', 'true');
        }
      }
    }

    function focusTab(index) {
      if (tabs[index]) {
        tabs[index].focus();
      }
    }

    activate(0);

    for (var j = 0; j < tabs.length; j++) {
      (function (index) {
        tabs[index].addEventListener('pointerenter', function () {
          activate(index);
        });

        tabs[index].addEventListener('focus', function () {
          activate(index);
        });

        tabs[index].addEventListener('keydown', function (event) {
          var nextIndex = index;

          if (event.key === 'ArrowDown') {
            nextIndex = (index + 1) % tabs.length;
          } else if (event.key === 'ArrowUp') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          activate(nextIndex);
          focusTab(nextIndex);
        });
      })(j);
    }
  }

  function enhanceCompactSubmenus() {
    var submenus = document.querySelectorAll('.menu-list__submenu-inner');

    for (var i = 0; i < submenus.length; i++) {
      if (submenus[i].querySelector('.ap-mega')) continue;

      var childLinks = submenus[i].querySelectorAll('.mega-menu__link:not(.mega-menu__link--parent)');
      if (childLinks.length > 0 && childLinks.length <= COMPACT_THRESHOLD) {
        submenus[i].classList.add('menu-list__submenu-inner--compact');
      }
    }
  }

  var megaMenus = document.querySelectorAll('.ap-mega');
  for (var i = 0; i < megaMenus.length; i++) {
    enhanceAllProductsMenu(megaMenus[i]);
  }

  enhanceCompactSubmenus();
})();
